import { MongoId } from '@orgbrain/lib-data';
import { SignOrderV2 } from '@orgbrain/lib-signing';
import { EmissionEvent, ShareholderEvent, ShareholderRecord } from './shared';

export enum EmissionPlanErrorCodes {
  EMAIL_EXISTS = 'EMAIL_EXISTS',
}

export enum EmissionPlanPositionState {
  NO_DOCUMENT = 'NO_DOCUMENT',
  DOCUMENT_READY_FOR_SIGNING = 'DOCUMENT_READY_FOR_SIGNING',
  DOCUMENT_SIGNED = 'DOCUMENT_SIGNED',
}

export interface EmissionPlanPosition {
  entityId: string;
  positionSize: number;
  maxPositionSize?: number;
  state?: EmissionPlanPositionState;
  signOrderId?: string;
  contract?: string;
  signingOrder?: SignOrderV2;
  confirmedInformation?: boolean;
  id?: any;
  name?: any;
  datePaid?: string;
  totalPaid?: number;
  datePaymentEmailSent?: string;
}

export interface EmissionInvitee {
  email: string;
  entityId?: string;
}

export interface EmissionPlan {
  // Common fields
  organizationId: MongoId;
  completed: boolean; // When plan has been commited (should have been called commited...) Means it's been incorporated in the transaction history
  pricePerShare: number;
  shareclass: string;
  dateAddedToTaxRegistery?: string;
  automatic?: boolean;
  createdAt?: string;
  title?: string;
  internalComment?: string;
  event?: string;
  sendEmails?: boolean;
  emailtext?: string;
  sendToSelected?: string[];
  banknr?: string;
  sharesBeforeEmission?: number;

  // Emission plan COMPLETED
  positions?: EmissionPlanPosition[];
  completedDate?: string;
  _id?: string;
  addedToRegisteryDate?: string;

  // Automatic
  parentIdForFiles?: string;
  path?: string;
  subscriptionFolderId?: string;
  attachments?: any[];
  minPerShareholder?: number;
  maxPerShareholder?: number;
  maxForIssue?: number;
  minForIssue?: number;
  sharesAfterEmission?: number;
  description?: string;
  totalVisibleToInvestors?: boolean;
  subtype?: string;
  isClone?: boolean;
}

export interface PaymentInformationEmailPayload {
  banknr: string;
  dueDate: string;
  emissionPlanId: string;
  positions: EmissionPlanPosition[];
  emailText: string;
}

export namespace EmissionPlans {
  export function findEventAndMergePositions(
    emissionPlans: EmissionPlan[],
    eventsMap: { [emissionPlanRef: string]: ShareholderEvent }
  ) {
    return emissionPlans.map((emissionPlan: EmissionPlan): EmissionPlan => {
      const event = eventsMap[emissionPlan._id] as EmissionEvent;
      if (event) {
        return {
          ...emissionPlan,
          positions: event.state.records.map((record: ShareholderRecord): EmissionPlanPosition => {
            return {
              entityId: record.entityId,
              positionSize: record.amount,
            };
          }),
        };
      } else {
        return emissionPlan;
      }
    });
  }
  export function folderName(emissionPlan: EmissionPlan): string {
    const date = (emissionPlan.completedDate && new Date(emissionPlan.completedDate)) || new Date();
    const title = emissionPlan.title || 'Emisjon';
    const foldername = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${title}`;
    return foldername;
  }

  export function documentSigned(position: EmissionPlanPosition): boolean {
    return (
      position.signingOrder &&
      position.signingOrder.signees &&
      position.signingOrder.signees[0] &&
      position.signingOrder.signees[0].proofs &&
      position.signingOrder.signees[0].proofs.length !== 0
    );
  }
}
